import React from "react";
import { useState, useEffect, useCallback } from "react";
import { Dialog } from "@material-ui/core";
import { Toolbar } from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { List } from "@material-ui/core";
import { Tooltip } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import "react-phone-number-input/style.css";
import { ApiDelete, ApiGet, ApiPost, ApiPut } from "../../../helpers/API/ApiData";
import TransactionIcon from "../../_assets/plugins/keenthemes-icons/svg/Transaction_Icon.png";
import { toast, ToastContainer } from "react-toastify";
import DataTable, { defaultThemes } from "react-data-table-component";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { getUserInfo } from "../../../utils/user.util";
import moment from "moment";
import { withGoogleMap, GoogleMap, withScriptjs, Marker } from "react-google-maps";
import { compose, withProps } from "recompose";
import Storeitem from "../StoreItam/StoreItam";
import StoreWiseOrderData from "../StorwiseOrderData/StoreWiseOrderData";
import AddPrizeImg from "../../_assets/plugins/keenthemes-icons/svg/buttonImg.png";
import StoreHomeImg from "../../_assets/plugins/keenthemes-icons/svg/home-icon.png";
import "react-image-crop/src/ReactCrop.scss";
import AddStore from "./AddStore";

const apiKey = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBwyQ2fI1UgcPSJJ8HuYLhVQRFHYpB0iRE&v=3.exp&libraries=geometry,drawing,places";

const MyMapComponent = compose(
  withProps({
    googleMapURL: apiKey,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props) => (
  <GoogleMap defaultZoom={4} defaultCenter={{ lat: props?.latitude, lng: props?.longtitude }} onClick={(e) => props?.handleClickedMap(e)}>
    <Marker position={{ lat: props?.latitude, lng: props?.longtitude }} />
  </GoogleMap>
));

export default function Store() {
  const userInfo = getUserInfo();
  const [uploadedImage, setUploadedImage] = useState(null);

  const [storeData, setStoreData] = useState({});
  const [addStore, setAddStore] = useState(false);
  const [errors, setErrors] = useState({});
  const [getAllStore, setGetAllStore] = useState({});
  const [isEditApi, setIsEditApi] = useState(false);
  const [search, setSearch] = useState();
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [storeIdForEdit, setStoreIdForEdit] = useState();
  const [setStoreIdForDelete] = useState();
  const [countPerPage, setCountPerPage] = useState(10);
  const [loader, setLoader] = useState(false);
  const [loaderForGetAll, setLoaderForGetAll] = useState(false);
  const [errorsForPhoto, setErrorsForPhoto] = useState({});
  const [latitude, Setlatitude] = useState(-34.78702602419161);
  const [longtitude, Setlongtitude] = useState(-34.78702602419161);
  const [show, setShow] = useState(false);
  const [showItamData, setShowItamData] = useState(false);
  const [userData, setUserData] = useState({});
  const [showMoreStoreData, setShowMoreStoreData] = useState({});
  const [openMoreStoreData, setOpenMoreStoreData] = useState(false);
  const [openOrderData, setOpenOrderData] = useState(false);
  const [storeOrderData, setStorOrderData] = useState({});
  const [phoneInput, setphoneInput] = useState("");
  const [crop, setCrop] = useState({
    unit: "%", // Can be 'px' or '%'
    x: 25,
    y: 25,
    width: 200,
    height: 200,
    maxHeight: 200,
    maxWidth: 200,
  });

  const [monthDay, setMonthDay] = useState([
    { day: "Monday", closed: false, open: "", close: "" },
    { day: "tuesday", closed: false, open: "", close: "" },
    { day: "wednesday", closed: false, open: "", close: "" },
    { day: "thursday", closed: false, open: "", close: "" },
    { day: "friday", closed: false, open: "", close: "" },
    { day: "saturday", closed: false, open: "", close: "" },
    { day: "sunday", closed: false, open: "", close: "" },
  ]);

  console.log("monthDay", monthDay?.length);

  // customTime: [{
  //   day: String,
  //   open: String,
  //   close: String,
  //   closed: Boolean
  // }, {{
  //   day: String,
  //   open: String,
  //   close: String,
  //   closed: Boolean
  // }}],

  const handleClickedMap = (e) => {
    Setlatitude(e.latLng.lat());
    Setlongtitude(e.latLng.lng());
  };

  useEffect(() => {
    getAllStoreData();
    getAllUser();
  }, [page, countPerPage]);

  function isValidURL(string) {
    var res = string.match(/(https?:\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    return res !== null;
  }

  const addStoreModelClose = (e) => {
    setAddStore(false);
    setIsEditApi(false);
    setErrors(false);
    setStoreData({});
  };

  const ShoworderModelClose = () => {
    setOpenOrderData(false);
  };

  const getAllUser = async () => {
    await ApiGet(`user/find`)
      .then((res) => {
        ApiGet(`user/find?limit=${res?.data?.count}`).then((res) => {
          setUserData(res?.data?.payload);
        });
      })

      .catch((err) => {});
  };

  console.log("sefsefsfsf", storeData);

  const onhandleChange = (e) => {
    e.target.value.replace(/[^a-zA-Z]/g, "");
    const { name, value } = e.target;
    console.log("sdjgfadsfc", name, value);

    setErrors({ ...errors, [name]: "" });
    if (name === "coinIcon" || name === "delivery" || name === "digital" || name === "brickandmortar" || name === "isFeatured") {
      setStoreData({ ...storeData, [name]: e.target.checked });
      return;
    }
    setStoreData({ ...storeData, [name]: value });
  };

  const onhandlecustometabChange = (e, index) => {
    const { checked } = e.target;
    monthDay[index].closed = checked;
    setMonthDay([...monthDay]);
  };

  const onhandleMonthChange = (e, index) => {
    const { name, value } = e.target;
    monthDay[index][name] = value;

    setMonthDay([...monthDay]);
  };

  const handleOnChnageAddImg = (e) => {
    const { name } = e.target;
    console.log("@storeData@", name);

    const file = e.target.files[0];
    const image = new Image();
    image.src = URL.createObjectURL(file);

    image.onload = () => {
      console.log("@#@", "H:", image.naturalHeight, "W", image.naturalWidth);

      if (name === "storeImage") {
        if (image.naturalHeight > 201 || image.naturalWidth > 201) {
          return toast.error(`Please enter 200*200 : Your image is ${image.naturalWidth} * ${image.naturalHeight} `);
        } else {
          return setStoreData({ ...storeData, [name]: file });
          // setErrorsForPhoto({  [name]: "" });
        }
      } else {
        if (image.naturalHeight > 401 || image.naturalHeight < 301 || image.naturalWidth > 801 || image.naturalWidth < 701) {
          return toast.error(`Please enter 800*400 : Your image is ${image.naturalWidth} * ${image.naturalHeight}`);
        } else {
          return setStoreData({ ...storeData, [name]: file });
          // setErrorsForPhoto({  [name]: "" });
        }
      }
    };
  };
  const formValidation = () => {
    let formvalied = true;
    let errors = {};
    if (!storeData?.userId || storeData?.userId === "") {
      formvalied = false;
      errors["userId"] = "*Please select user.";
    }
    if (!phoneInput) {
      formvalied = false;
      errors["phone"] = "*Please enter phone number";
    }
    if (!storeData?.name?.trim() || storeData?.name === "") {
      formvalied = false;
      errors["name"] = "*Please enter name.";
    }

    if (storeData && !storeData?.storeImage) {
      formvalied = false;
      errors["storeImage"] = "*Please select image.";
    }
    if (!storeData?.email?.trim() || storeData?.email === "") {
      formvalied = false;
      errors["email"] = "*Please enter email.";
    }

    let isValidiosStoreLink = isValidURL(storeData?.url || "");
    if (!isValidiosStoreLink) {
      formvalied = false;
      errors["url"] = "*Please enter Valid url";
    }

    if (!storeData?.details?.trim() || storeData?.details === "") {
      formvalied = false;
      errors["details"] = "*Please enter details.";
    }

    if (!storeData?.description?.trim() || storeData?.description === "") {
      formvalied = false;
      errors["description"] = "*Please enter description.";
    }

    if (storeData?.brickandmortar === true) {
      if (!storeData?.address?.trim() || storeData?.address === "") {
        formvalied = false;
        errors["address"] = "*Please enter address.";
      }
      if (!storeData?.state?.trim() || storeData?.state === "") {
        formvalied = false;
        errors["state"] = "*Please enter state.";
      }
      if (!storeData?.zipCode || storeData?.zipCode === "") {
        formvalied = false;
        errors["zipCode"] = "*Please enter zip-code.";
      }
      if (!storeData?.city?.trim() || storeData?.city === "") {
        formvalied = false;
        errors["city"] = "*Please enter city.";
      }
      if (!storeData?.country || storeData?.country === "") {
        formvalied = false;
        errors["country"] = "*Please enter country.";
      }
      if (!monthDay?.closed === false || storeData?.country === "") {
        formvalied = false;
        errors["customHours"] = "*Please enter country.";
      }
    }

    // if (
    //   // monthDay[i].closed === false &&
    //   monthDay[0].open === "" ||
    //   monthDay[0].close === ""
    // ) {
    //   formvalied = false;
    //   errors["closed"] = "*Please enter customHours.";
    // }

    for (var i = 0; i <= 6; i++) {
      if (monthDay[i].closed === false) {
        if (monthDay[i].open === "" || monthDay[i].close === "") {
          formvalied = false;
          errors[`closed${i}`] = "*Please enter customHours.";
        }
      }
    }

    setErrors(errors);
    return formvalied;
  };

  const handleClose = () => {
    setShow(false);
  };
  const ShowItamDataModelClose = () => {
    setShowItamData(false);
    getAllStoreData();
  };

  const handleShowStoreItamData = (data) => {
    setGetAllStore(data);
  };

  const getAllStoreData = async () => {
    setLoaderForGetAll(true);
    let url = search ? `&letter=${search}` : "";
    await ApiGet(userInfo?.role === "owner" ? `store/find?userId=${userInfo?._id}${url}` : `store/find?page=${page}&limit=${countPerPage}${url}`)
      .then((res) => {
        console.log("yyyyyy", res?.data?.payload);
        setGetAllStore(res?.data?.payload);
        setCount(res?.data?.count);
        setLoaderForGetAll(false);
      })
      .catch((err) => {
        setLoaderForGetAll(false);
      });
  };

  const addStoreData = async (e) => {
    setIsEditApi(false);
    // if (formValidation()) {
    setLoader(true);
    const isCustomHours = storeData?.customHours === true;

    let formData = new FormData();

    // let fileArr = Array.from(monthDay);
    //   fileArr.forEach((file) => {
    //     formData.append("customTime",JSON.stringify(file));
    //   });

    formData.append("userId", storeData?.userId);
    formData.append("name", storeData?.name);
    formData.append("details", storeData?.details);
    formData.append("coinIcon", storeData?.coinIcon === true ? true : false);
    formData.append("delivery", storeData?.delivery === true ? true : false);
    formData.append("digital", storeData?.digital === true ? true : false);
    formData.append("brickandmortar", storeData?.brickandmortar === true ? true : false);
    formData.append("isFeatured", storeData?.isFeatured === true ? true : false);
    formData.append("email", storeData?.email);
    formData.append("url", storeData?.url);
    formData.append("phone", phoneInput);
    formData.append("description", storeData?.description);
    formData.append("address", storeData?.address);
    formData.append("state", storeData?.state);
    formData.append("zipCode", storeData?.zipCode);
    formData.append("city", storeData?.city);
    formData.append("country", storeData?.country);
    // formData.append("storeImage", uploadedImage);
    formData.append("storeImage", storeData?.storeImage);
    formData.append("storeImageThumbnail", storeData?.storeImageThumbnail);
    formData.append("lat", latitude);
    formData.append("long", longtitude);
    formData.append("customHours", isCustomHours);
    formData.append("customHoursType", storeData?.customHoursType);
    formData.append("customTime", JSON.stringify(monthDay));
    // formData.append("status", storeData?.status);

    await ApiPost(`store/create`, formData)
      .then((res) => {
        toast.success("Store add successfully");
        setAddStore(false);
        setMonthDay([]);
        setIsEditApi(false);
        getAllStoreData();
        setStoreData({});
        setLoader(false);
        Setlongtitude("");
        Setlatitude("");
        setphoneInput("");
      })
      .catch((err) => {
        toast.error(err?.response?.statusText);
        setLoader(false);
      });
    // }
  };

  console.log("fsfefgsefaef", storeData);

  const editStoreData = async (e) => {
    // if (formValidation()) {
    const isCustomHours = storeData?.customHours === true;
    let formData = new FormData();

    // formData.append("userId", storeData?.userId);
    formData.append("name", storeData?.name);
    formData.append("details", storeData?.details);
    formData.append("coinIcon", storeData?.coinIcon === true ? true : false);
    formData.append("delivery", storeData?.delivery === true ? true : false);
    formData.append("digital", storeData?.digital === true ? true : false);
    formData.append("brickandmortar", storeData?.brickandmortar === true ? true : false);
    formData.append("isFeatured", storeData?.isFeatured === true ? true : false);
    formData.append("email", storeData?.email);
    formData.append("url", storeData?.url);
    formData.append("phone", phoneInput);
    formData.append("description", storeData?.description);
    formData.append("address", storeData?.address ? storeData?.address : "");
    formData.append("state", storeData?.state ? storeData?.state : "");
    formData.append("zipCode", storeData?.zipCode ? storeData?.zipCode : "");
    formData.append("city", storeData?.city ? storeData?.city : "");
    formData.append("country", storeData?.country ? storeData?.country : "");
    formData.append("storeImage", storeData?.storeImage);
    formData.append("storeImageThumbnail", storeData?.storeImageThumbnail);
    formData.append("lat", latitude);
    formData.append("long", longtitude);
    formData.append("customHours", isCustomHours);
    formData.append("customHoursType", storeData?.customHoursType);
    formData.append("customTime", JSON.stringify(monthDay));
    formData.append("status", storeData?.status);

    setLoader(true);
    await ApiPut(`store/update?id=${storeIdForEdit}`, formData)
      .then((res) => {
        toast.success("Store update successfully");
        getAllStoreData();
        setAddStore(false);
        setIsEditApi(false);
        setStoreData([]);
        setLoader(false);
      })
      .catch((err) => {
        toast.error(err?.response?.statusText);
        setLoader(false);
      });
    // }
  };

  const deleteStoreData = async () => {
    await ApiDelete(`store/delete?id=${setStoreIdForDelete}`)
      .then((res) => {
        if (res?.status === 200) {
          toast.success("Delete Store successfully");
          setShow(false);
          getAllStoreData();
        } else {
          toast.error("something went wrong please try again");
        }
      })
      .catch((err) => {
        toast.error(err?.response?.statusText);
      });
  };

  const updatestatus = (e, row) => {
    let body = {
      storeId: row?._id,
      isSuspend: row?.isSuspend === true ? false : true,
    };

    ApiPut(`store/updateStatus`, body)
      .then((res) => {
        toast.success("Status Update Successfully");
        getAllStoreData();
      })
      .catch((error) => {
        toast.error(error?.response?.statusText);
      });
  };

  const handleSearch = (e) => {
    let val = e.target.value.replace(/[^\w\s!@#$%^&*-=+]/gi, "");
    setSearch(val);
  };
  const debouncedSearchTerm = useDebounce(search, 500);
  function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => {
        clearTimeout(handler);
      };
    }, [value, delay]);
    return debouncedValue;
  }
  useEffect(() => {
    if (debouncedSearchTerm) {
      setPage(1);
      setCount(0);
      setCountPerPage(countPerPage);
      getAllStoreData();
    } else {
      setPage(1);
      setCount(0);
      setCountPerPage(countPerPage);
      getAllStoreData();
    }
  }, [debouncedSearchTerm]);

  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: defaultThemes.default.divider.default,
      },
    },
    headCells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
    cells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
  };
  const conditionalRowStyles = [
    {
      when: (row) => row,
      style: {
        backgroundColor: "lightgrey",
        color: "#040761",
        // userSelect: "none"
      },
    },
  ];

  const columns = [
    {
      name: "SNr.",
      selector: (row, index) => (page - 1) * countPerPage + (index + 1),
      width: "5%",
    },
    {
      name: "Joined on",
      selector: (row) => moment(row?.createdAt).format("Do MMM YYYY"),
      width: "10%",
    },
    {
      name: "Name",
      selector: (row) => row?.name,
      width: true,
    },
    {
      name: "Email",
      selector: (row) => row?.email,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => {
        return (
          <>
            <div className="d-flex justify-content-between mr-3">
              <div className="cursor-pointer pl-2">
                <button
                  style={{
                    background: "#002a5a",
                    color: "white",
                    borderRadius: "20px",
                    whiteSpace: "nowrap",
                  }}
                  onClick={(e) => {
                    setIsEditApi(true);
                    setAddStore(true);
                    setStoreIdForEdit(row?._id);
                    console.log("rowwwwwww", row);
                    setphoneInput(row?.phone);
                    setStoreData({
                      name: row?.name,
                      details: row?.details,
                      email: row?.email,
                      url: row?.url,
                      coinIcon: row?.coinIcon,
                      delivery: row?.delivery,
                      digital: row?.digital,
                      brickandmortar: row?.brickandmortar,
                      isFeatured: row?.isFeatured,
                      description: row?.description,
                      address: row?.address,
                      state: row?.state,
                      zipCode: row?.zipCode,
                      city: row?.city,
                      country: row?.country,
                      storeImage: row?.storeImage,
                      customHours: row?.customHours,
                      customHoursType: row?.customHoursType,
                      customTime: row?.customTime,
                      lat: row?.location?.coordinates[0],
                      long: row?.location?.coordinates[1],
                      status: row?.status,
                      storeImageThumbnail: row?.storeImageThumbnail,
                    });
                  }}
                >
                  {/* <Tooltip title="edit Store" arrow> */}
                  Manage
                  {/* </Tooltip> */}
                </button>
              </div>
            </div>
          </>
        );
      },
      sortable: true,
    },

    {
      name: "Prize Case",
      cell: (row) => {
        return (
          <>
            <button
              style={{
                background: "yellow",
                color: "black",
                borderRadius: "20px",
                fontWeight: "bold",
              }}
              onClick={(e) => {
                setShowItamData(true);
                handleShowStoreItamData(row);
              }}
            >
              Prizes
            </button>
          </>
        );
      },
      width: "10%",
    },

    {
      name: "Reservation Details",
      cell: (row) => {
        return (
          <>
            <div className="d-flex justify-content-center m-auto">
              <div
                className="cursor-pointer pl-2"
                onClick={(e) => {
                  setOpenOrderData(true);
                  setStorOrderData(row);
                }}
              >
                <Tooltip title="Reservation Details" arrow>
                  <button
                    style={{
                      background: "white",
                      color: "black",
                      borderRadius: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    View
                  </button>
                </Tooltip>
              </div>
            </div>
          </>
        );
      },
      sortable: true,
      width: "10%",
    },
    {
      name: "Status",
      cell: (row) => {
        return (
          <>
            {row?.status === "active" && (
              <div
                style={{
                  background: "#22cc00",
                  color: "white",
                  fontWeight: "bold",
                  height: "50px",
                  width: "250px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "0",
                  }}
                >
                  Active
                </p>
              </div>
            )}
            {row?.status === "suspended" && (
              <div
                style={{
                  background: "red",
                  height: "50px",
                  fontWeight: "bold",
                  width: "250px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "0",
                  }}
                >
                  Suspend
                </p>
              </div>
            )}
            {row?.status === "pushToTop" && (
              <div
                style={{
                  background: "#29b6f6",
                  color: "white",
                  height: "50px",
                  fontWeight: "bold",
                  width: "250px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "0",
                  }}
                >
                  Push To Top
                </p>
              </div>
            )}
          </>
        );
      },
      sortable: true,
    },
    {
      name: "More Information",
      cell: (row) => {
        return (
          <>
            <div className="d-flex justify-content-center m-auto">
              <div
                className="cursor-pointer pl-2"
                onClick={(e) => {
                  setShowMoreStoreData(row);
                  setOpenMoreStoreData(true);
                }}
              >
                <Tooltip title="Store Details" arrow>
                  <InfoOutlinedIcon data-toggle="modal" data-target="#exampleModalCenter" />
                </Tooltip>
              </div>
            </div>
          </>
        );
      },
      sortable: true,
      width: "10%",
    },
  ];
  const columns1 = [
    {
      name: "SNr.",
      selector: (row, index) => (page - 1) * countPerPage + (index + 1),
      width: "5%",
    },
    {
      name: "Joined on",
      selector: (row) => moment(row?.createdAt).format("Do MMM YYYY"),
      width: "10%",
    },
    {
      name: "Name",
      selector: (row) => row?.name,
      width: true,
    },
    {
      name: "Email",
      selector: (row) => row?.email,
      sortable: true,
    },

    // {
    //   name: "Action",
    //   cell: (row) => {
    //     return (
    //       <>
    //         <div className="d-flex justify-content-between mr-3">
    //           <div
    //             className="cursor-pointer pl-2"

    //           >
    //             <button
    //               style={{
    //                 background: "#002a5a",
    //                 color: "white",
    //                 borderRadius: "20px",
    //                 whiteSpace: "nowrap"
    //               }}
    //               onClick={(e) => {
    //                 setIsEditApi(true);
    //                 setAddStore(true);
    //                 setStoreIdForEdit(row?._id);
    //                 console.log("rowwwwwww", row);
    //                 setStoreData({
    //                   name: row?.name,
    //                   details: row?.details,
    //                   email: row?.email,
    //                   url: row?.url,
    //                   phone: row?.phone,
    //                   coinIcon: row?.coinIcon,
    //                   delivery: row?.delivery,
    //                   digital: row?.digital,
    //                   brickandmortar: row?.brickandmortar,
    //                   description: row?.description,
    //                   address: row?.address,
    //                   state: row?.state,
    //                   zipCode: row?.zipCode,
    //                   city: row?.city,
    //                   country: row?.country,
    //                   storeImage: row?.storeImage,
    //                   customHours: row?.customHours,
    //                   customTime: row?.customTime,
    //                   lat: row?.location?.coordinates[0],
    //                   long: row?.location?.coordinates[1],
    //                   status: row?.status
    //                 });
    //               }}
    //             >
    //               {/* <Tooltip title="edit Store" arrow> */}

    //               Manage
    //               {/* </Tooltip> */}

    //             </button>
    //           </div>
    //         </div>
    //       </>
    //     );
    //   },
    //   sortable: true,
    // },

    // {
    //   name: "Prize Case",
    //   cell: (row) => {
    //     return (
    //       <>
    //         <button
    //           style={{
    //             background: "yellow",
    //             color: "black",
    //             borderRadius: "20px",
    //             fontWeight: "bold",
    //           }}
    //           onClick={(e) => {
    //             setShowItamData(true);
    //             handleShowStoreItamData(row);
    //           }}
    //         >
    //           Prizes
    //         </button>
    //       </>
    //     );
    //   },
    //   width: "10%",
    // },

    {
      name: "Reservation Details",
      cell: (row) => {
        return (
          <>
            <div className="d-flex justify-content-center m-auto">
              <div
                className="cursor-pointer pl-2"
                onClick={(e) => {
                  setOpenOrderData(true);
                  setStorOrderData(row);
                }}
              >
                <Tooltip title="Reservation Details" arrow>
                  <button
                    style={{
                      background: "white",
                      color: "black",
                      borderRadius: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    View
                  </button>
                </Tooltip>
              </div>
            </div>
          </>
        );
      },
      sortable: true,
      width: "10%",
    },
    {
      name: "Status",
      cell: (row) => {
        return (
          <>
            {row?.status === "active" && (
              <div
                style={{
                  background: "#22cc00",
                  color: "white",
                  fontWeight: "bold",
                  height: "50px",
                  width: "250px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "0",
                  }}
                >
                  Active
                </p>
              </div>
            )}
            {row?.status === "deactivated" && (
              <div
                style={{
                  background: "red",
                  height: "50px",
                  fontWeight: "bold",
                  width: "250px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "0",
                  }}
                >
                  De Actived
                </p>
              </div>
            )}
          </>
        );
      },
      sortable: true,
    },
    {
      name: "More Information",
      cell: (row) => {
        return (
          <>
            <div className="d-flex justify-content-center m-auto">
              <div
                className="cursor-pointer pl-2"
                onClick={(e) => {
                  setShowMoreStoreData(row);
                  setOpenMoreStoreData(true);
                }}
              >
                <Tooltip title="Order Details" arrow>
                  <InfoOutlinedIcon data-toggle="modal" data-target="#exampleModalCenter" />
                </Tooltip>
              </div>
            </div>
          </>
        );
      },
      sortable: true,
      width: "10%",
    },
  ];

  useEffect(() => {
    if (storeData?.customTime?.length) setMonthDay([...storeData?.customTime]);
  }, [storeData]);

  return (
    <>
      <div className="card p-1">
        <ToastContainer />
        <div className="heading-banner d-flex justify-content-center">
          <div className="align-items-center d-flex">
            <img src={TransactionIcon} alt="TransactionIcon" className="exchangeImg" />
            <div className="client-details pl-2">
              <h1 className="text-white">{count}</h1>
              <h6 className="text-white">Stores Online</h6>
            </div>
          </div>
        </div>
        <div className="p-2 mb-2">
          <div className="row mb-4 pr-3 align-items-center justify-content-between">
            <div className="d-flex justify-content-between">{/* <h2 className="pl-3 pt-2">Stores</h2> */}</div>
            <div className="cus-medium-button-style button-height button-details-alignment">
              {userInfo?.role === "admin" && (
                <button
                  className="btn"
                  onClick={() => {
                    setAddStore(true);
                  }}
                >
                  <img src={AddPrizeImg} alt={AddPrizeImg} />
                  <img src={StoreHomeImg} alt="StoreHomeImg" />
                  Add Store
                </button>
              )}
            </div>
            <div className="">
              <div>
                <input
                  type="text"
                  className={`form-control rounded-lg custom-style `}
                  name="search"
                  value={search}
                  onChange={(e) => handleSearch(e)}
                  placeholder="Search"
                />
              </div>
            </div>
          </div>
        </div>

        {loaderForGetAll ? (
          <div className="text-center">
            <div className="spinner-border"></div>
          </div>
        ) : (
          <DataTable
            columns={userInfo?.role === "admin" ? columns : columns1}
            data={getAllStore}
            customStyles={customStyles}
            conditionalRowStyles={conditionalRowStyles}
            highlightOnHover
            pagination
            paginationServer
            paginationTotalRows={count}
            paginationPerPage={countPerPage}
            paginationRowsPerPageOptions={[10, 20, 25, 50, 100]}
            paginationDefaultPage={page}
            onChangePage={(page) => {
              setPage(page);
            }}
            onChangeRowsPerPage={(rowPerPage) => {
              setCountPerPage(rowPerPage);
            }}
          />
        )}
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="text-danger">Alert!</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this Store?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            No
          </Button>
          <Button variant="danger" onClick={() => deleteStoreData()}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      {addStore === true ? (
        <AddStore
          addStore={addStore}
          addStoreModelClose={addStoreModelClose}
          isEditApi={isEditApi}
          userInfo={userInfo}
          storeData={storeData}
          onhandleChange={onhandleChange}
          userData={userData}
          errors={errors}
          handleOnChnageAddImg={handleOnChnageAddImg}
          phoneInput={phoneInput}
          setphoneInput={setphoneInput}
          setStoreData={setStoreData}
          monthDay={monthDay}
          onhandlecustometabChange={onhandlecustometabChange}
          onhandleMonthChange={onhandleMonthChange}
          MyMapComponent={MyMapComponent}
          longtitude={longtitude}
          handleClickedMap={handleClickedMap}
          latitude={latitude}
          loader={loader}
          editStoreData={editStoreData}
          addStoreData={addStoreData}
        />
      ) : null}

      {showItamData === true ? (
        <Dialog fullScreen open={showItamData}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={() => ShowItamDataModelClose()} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
          <List>
            <>
              <Storeitem getAllStore={getAllStore} />
            </>
          </List>
        </Dialog>
      ) : null}

      {openMoreStoreData === true ? (
        <>
          <div
            class="modal fade"
            id="exampleModalCenter"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
            style={{ backdropFilter: "brightness(0.5)" }}
          >
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h2 class="modal-title" id="exampleModalLongTitle">
                    More Information
                  </h2>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <h4>Description</h4>
                  <p>{showMoreStoreData?.description}</p>

                  <h4>Details</h4>
                  <p>{showMoreStoreData?.email}</p>

                  <h4>Phone</h4>
                  <p>{showMoreStoreData?.phone}</p>

                  <h4>Address</h4>
                  <p>{showMoreStoreData?.address}</p>

                  <h4>State</h4>
                  <p>{showMoreStoreData?.state}</p>

                  <h5>Zipcode</h5>
                  <p>{showMoreStoreData?.zipCode}</p>

                  <h4>Image</h4>
                  <img style={{ width: 200, height: 200 }} src={showMoreStoreData.storeImage} />
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal" onClick={(e) => setOpenMoreStoreData(false)}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}

      {openOrderData === true ? (
        <Dialog fullScreen open={openOrderData}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={() => ShoworderModelClose()} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
          <List>
            <>
              <StoreWiseOrderData storeOrderData={storeOrderData} />
            </>
          </List>
        </Dialog>
      ) : null}
    </>
  );
}
